
export const DQ_DIMENSIONS = [
    "completeness",
    "uniqueness",
    "consistency",
    "validity",
    "accuracy",
    "freshness",
  ];